import { produce } from "immer";
import {
  FETCH_ALLERGY,
  FETCH_ALLERGY_SUCCESS,
  FETCH_ALLERGY_FAILURE,
  //
  ADD_ALLERGY,
  ADD_ALLERGY_SUCCESS,
  ADD_ALLERGY_FAILURE,
  //
  EDIT_ALLERGY,
  EDIT_ALLERGY_SUCCESS,
  EDIT_ALLERGY_FAILURE,
  //
  DELETE_ALLERGY,
  DELETE_ALLERGY_SUCCESS,
  DELETE_ALLERGY_FAILURE,
  //
  FETCH_ALLERGY_REGISTER,
  FETCH_ALLERGY_REGISTER_SUCCESS,
  FETCH_ALLERGY_REGISTER_FAILURE,
  //
  REGISTER_DATA_TOUCHED,
  //
  SET_REGISTER_ASSERTION,
  SET_REGISTER_ASSERTION_SUCCESS,
  SET_REGISTER_ASSERTION_FAILURE,
  //
  TOGGLE_ALLERGY_MODAL,
} from "./constants";

export const initialState = {
  isFetchingAllergy: false,
  allergy: [],
  // Add / Edit
  isSubmitting: false,
  // Delete
  isDeleting: false,
  allergyModal: { open: false, isEditing: false, currentAllergy: null },
  // Register facade — keyed `${residentId}:${registerKey}` so summary + full
  // facades (and different residents) never clobber each other.
  registers: {},
  registersFetching: {},
  // Keyed like registersFetching: the last fetch for this (resident, register)
  // FAILED. The facade still degrades silently for its advisory readers (chips,
  // toggles — no toast), but a register surface reads this to tell "the fetch
  // failed" apart from "nothing is recorded", and only the second may render
  // as an empty register.
  registersError: {},
  isSavingAssertion: false,
  // Bumped on any register CRUD (REGISTER_DATA_TOUCHED) so the top-bar chips,
  // which count register rows once per resident, refetch without a remount.
  registerDataVersion: 0,
};

const ResidentAllergyReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_ALLERGY:
        draft.isFetchingAllergy = true;
        draft.allergy = {};
        break;
      case FETCH_ALLERGY_SUCCESS:
        draft.isFetchingAllergy = false;
        draft.allergy = action.payload;
        break;
      case FETCH_ALLERGY_FAILURE:
        draft.allergy = {};
        draft.isFetchingAllergy = false;
        break;
      // Add
      case ADD_ALLERGY:
        draft.isSubmitting = true;
        break;
      case ADD_ALLERGY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_ALLERGY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_ALLERGY:
        draft.isSubmitting = true;
        break;
      case EDIT_ALLERGY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_ALLERGY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_ALLERGY:
        draft.isDeleting = true;
        break;
      case DELETE_ALLERGY_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ALLERGY_FAILURE:
        draft.isDeleting = false;
        break;
      // Register facade
      case FETCH_ALLERGY_REGISTER: {
        const { residentId, registerKey = "allergies" } = action.payload ?? {};
        draft.registersFetching[`${residentId}:${registerKey}`] = true;
        draft.registersError[`${residentId}:${registerKey}`] = false;
        break;
      }
      case FETCH_ALLERGY_REGISTER_SUCCESS:
        draft.registers[action.payload.key] = action.payload.data;
        draft.registersFetching[action.payload.key] = false;
        draft.registersError[action.payload.key] = false;
        break;
      case FETCH_ALLERGY_REGISTER_FAILURE:
        draft.registersFetching[action.payload.key] = false;
        draft.registersError[action.payload.key] = true;
        break;
      // A register changed anywhere — nudge readers that fetch once per resident.
      case REGISTER_DATA_TOUCHED:
        draft.registerDataVersion += 1;
        break;
      // Register assertion
      case SET_REGISTER_ASSERTION:
        draft.isSavingAssertion = true;
        break;
      case SET_REGISTER_ASSERTION_SUCCESS:
        draft.isSavingAssertion = false;
        break;
      case SET_REGISTER_ASSERTION_FAILURE:
        draft.isSavingAssertion = false;
        break;
      case TOGGLE_ALLERGY_MODAL:
        draft.allergyModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default ResidentAllergyReducer;
